import { useEffect, useState } from "react";
import makeStyles from '@mui/styles/makeStyles';

//components
import Grid from "@mui/material/Grid";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Knob as Knob2 } from "components/shared/ReactRotaryKnob";
import LeftPanel from "components/leftPanel";

//assets
import bigNextButton from "assets/phase4/next.png";
import bigPrevButton from "assets/phase4/back.png";

import tempoIndicator from "assets/phase2/tempo.png";
import transposeIndicator from "assets/phase2/transpose.png";
import volumeIndicator from "assets/phase2/volume.png";

import blankAlbumArtLeftPart from "assets/phase4/TopLeftBlank.png";

//knob skins
import { seekerKnobSkinGenerator } from "assets/knobSkins/seeker";
import tempoKnobSkin from "assets/knobSkins/tempo";

//providers
import { useTimelineState } from "providers/TimelineProvider";

const useStyles = makeStyles((theme) => ({
  gridItems: {
    height: "100%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  masterVolumeContainer: {
    position: "relative",
    height: "100%",
    width: "100%",
    justifyContent: "center",
    display: "flex",
  },
}));

function LeftContainer({
  percentOfHeight,
  percentOfWidth,
  timestamps,
  currentTime,
  currentTrack,
  changeCurrentTimeByUser,
  handelVolumeChange,
  handelTempoChange,
  setTempoValue,
  resetTranspose,
  handelTransposeChange,
  rightContainerRef,
  handelNextTrack,
  handelPrevTrack,
  handelPause,
  handelPlay,
  containersHeight,
  defaultTempos,
  tempo,
  transpose,
  masterVolume,
  playState,
}) {
  const classes = useStyles();
  const [leftIndicatorState, setLeftIndicatorState] = useState("onTempo");

  const [tempoKnobValue, setTempoKnobValue] = useState(0);
  const [defaultTempo,setDefaultTempo] = useState(120);
  const [masterVolumeKnobValue, setMasterVolumeKnobValue] = useState(0);
  const [transposeKnobValue, setTransposeKnobValue] = useState(0);

  const [timeline, setTimeline] = useTimelineState();

  useEffect(() => {
    if (timeline && timeline.defaultTempo) {
      setTempoValue(timeline.defaultTempo);
      setDefaultTempo(timeline.defaultTempo);
    }
  }, [timeline,setTempoValue]);

  const handelVolumeKnobStartChange = () => {
    setLeftIndicatorState("onVolume");
  };
  const handelTempoKnobStartChange = () => {
    setLeftIndicatorState("onTempo");
  };
  const handelTempoChangeLocal = (value) => {
    if (value === tempoKnobValue) return;
    const rotateDirection = value > tempoKnobValue ? 1 : -1;
    setTempoKnobValue(value);
    handelTempoChange(rotateDirection);
  };

  const handelTransposeKnobStartChange = () => {
    setLeftIndicatorState("onTranspose");
  };
  const handelTransposeChangeLocal = (value) => {
    if (value === transposeKnobValue) return;
   
    const rotateDirection = value > transposeKnobValue ? 1 : -1;
    let changeValue = rotateDirection* (1/45.0);
    // const rotateDirection = (value - transposeKnobValue) * (1/90.0);
    setTransposeKnobValue(value);
    handelTransposeChange(changeValue);
  };

  return (
    <>
      <Grid
        item
        className={classes.gridItems}
        style={{
          height: percentOfHeight(11),
          width: "100%",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            position: "relative",
          }}
        >
          <img
            src={
              timeline?.leftAlbumArtUrl
                ? timeline?.leftAlbumArtUrl
                : blankAlbumArtLeftPart
            }
            style={{
              width: "38%",
              height: "79%",
              right: "0",
              position: "absolute",
            }}
          ></img>
        </div>
      </Grid>

      <Grid
        item
        className={classes.gridItems}
        style={{
          height: percentOfHeight(17),
          width: "100%",
          position: "relative",
        }}
      >
        <div
          style={{
            height: percentOfHeight(15),
            width: "94%",
            height: "84%",
            marginLeft: percentOfWidth(4),
            marginTop: percentOfHeight(0.8),
            paddingBottom: percentOfHeight(3),
            overflow: "hidden",
            borderRadius: percentOfHeight(1.5),
          }}
        >
          {percentOfWidth(18.4) && (
            <LeftPanel
              percentOfHeight={percentOfHeight}
              percentOfWidth={percentOfWidth}
              timestampArray={timestamps}
              bareSize={percentOfWidth(18.4)}
              currentTrack={currentTrack}
              currentTime={currentTime}
              setCurrentTime={changeCurrentTimeByUser}
              defaultTempo={timeline.defaultTempo}
            />
          )}
        </div>
      </Grid>

      <Grid
        //spacer div
        item
        className={classes.gridItems}
        style={{
          height: percentOfHeight(4),
          width: "100%",
        }}
      ></Grid>

      <Grid
        item
        style={{
          height: percentOfHeight(40),
          width: "100%",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            padding: "20% 27% 22% 31%",
          }}
        >
          <CircularProgressbar
            value={masterVolume}
            strokeWidth={5}
            styles={buildStyles({
              strokeLinecap: "butt",
              trailColor: "#d6d6d622",
              pathColor: `rgb(120,120,120)`,
              rotation: 0.5,
              path: {
                strokeDasharray: "0 1",
              },
            })}
          ></CircularProgressbar>
        </div>
        <div
          className={classes.masterVolumeContainer}
          style={{
            padding: `20% 27% 5% 31%`,
          }}
        >
          <Knob2
            style={{
              height: "100%",
              display: "inline-block",
              zIndex: 10,
              width: "100%",
            }}
            lineColor="#00ff00"
            maxDistance={parseInt(percentOfWidth(25).slice(0, -2))}
            mousePosition={true}
            skin={seekerKnobSkinGenerator(
              playState === "played" || playState === "seeked",
              {
                middle: "#9EFFA5",
                end: "#00FF14",
              }
            )}
            value={masterVolumeKnobValue || 0}
            unlockDistance={50}
            onChange={handelVolumeChange}
            onStart={handelVolumeKnobStartChange}
            onClick={(e) => {
              if (e) return;
              playState === "played" ? handelPause() : handelPlay();
            }}
          />
        </div>
      </Grid>
      <Grid
        item
        style={{
          height: percentOfHeight(8),
          width: "100%",
          position: "relative",
          marginLeft: "5%",
        }}
      >
        <Grid
          container
          spacing={0}
          columns={24}
          style={{
            height: "100%",
            width: "100%",
            justifyContent: "center",
            // margin
          }}
        >
          <Grid item xs={5} style={{ overflow: "show" }}>
            <div
              style={{
                backgroundImage: `url(${bigPrevButton})`,
                height: "220%",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                width: "150%",
                position: "relative",
                top: "-100%",
                left: "0%",
              }}
              onClick={handelPrevTrack}
            >
              &nbsp;
            </div>
          </Grid>
          <Grid
            item
            xs={4}
            className={classes.gridItems}
            // style={styles.gridItems}
            style={{ position: "relative", disabled:true}}
            
          >
        <div
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            top:"-25%",
            left:"-15%",
            padding: "0% 8% 0% 25%",
          }}
        >
          <CircularProgressbar
            // value={(tempo-59.0)/(240-60.0) * 100}
            value={100}
            strokeWidth={10}
            styles={buildStyles({
              strokeLinecap: "butt",
              trailColor: "#d6d6d622",
              pathColor: `rgb(0,0,0)`,
              rotation: 0.5,
              path: {
                strokeDasharray: "0 1",
              },
            })}
          ></CircularProgressbar>
        </div>
        <div
          className={classes.masterVolumeContainer}
          style={{
            // padding: `20% 27% 5% 31%`,
          }}
        >
          <Knob2
              style={{
                height: "100%",
                display: "inline-block",
                zIndex: 10,
                width: "90%",
                top: "-35%",
                left: "-10%",
                // opacity:0.3

              }}
              skin={tempoKnobSkin}
              // min={0}
              // max={100}
              // step={0.5}
              lineColor="#00ff00"
              mousePosition={true}
              value={tempoKnobValue || 0}
              unlockDistance={50}
              onChange={handelTempoChangeLocal}
              onStart={handelTempoKnobStartChange}
              onClick={(e) => {
                if (e) return;
                // let diff = defaultTempo - tempoKnobValue;
                setTempoValue(defaultTempo)
                console.log("defaultTempo:", defaultTempo)
              }}
            />
        </div>
            
          </Grid>
          <Grid item xs={6} className={classes.gridItems}>
            <div
              style={{
                width: "80%",
                height: "70%",
                marginTop: "5%",
                marginLeft: "10%",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "5%",
                zIndex: 20,
                backgroundImage:
                  leftIndicatorState === "onVolume"
                    ? `url(${volumeIndicator})`
                    : leftIndicatorState === "onTempo"
                    ? `url(${tempoIndicator})`
                    : `url(${transposeIndicator})`,
              }}
            >
              {/* empty padding to simulate 7segment display for tempo */}
              <p
                style={{
                  fontFamily: "digital",
                  display:
                    leftIndicatorState === "onTempo" && tempo < 100 && tempo > 9
                      ? "inline"
                      : "none",
                  color: "#00000000",
                }}
              >
                0
              </p>

              {/* empty padding to simulate 7segment display for tempo */}
              <p
                style={{
                  fontFamily: "digital",
                  display:
                    leftIndicatorState === "onVolume" &&
                    masterVolume < 100 &&
                    masterVolume > 9
                      ? "inline"
                      : "none",
                  color: "#00000000",
                }}
              >
                0
              </p>

              {/* empty padding to simulate 7segment display for transpose */}
              <p
                style={{
                  fontFamily: "digital",
                  display:
                    leftIndicatorState === "onTranspose" &&
                    transpose < 100 &&
                    transpose > 9
                      ? "inline"
                      : "none",
                  color: "#00000000",
                }}
              >
                0
              </p>

              <p style={{ fontFamily: "digital", display: "inline" }}>
                {leftIndicatorState === "onTempo"
                  ? Math.floor(tempo)
                  : leftIndicatorState === "onVolume"
                  ? Math.ceil(masterVolume)
                  : Math.round(transpose)}
              </p>
              {/* placeholder segments */}
              <p
                style={{
                  fontFamily: "digital",
                  display: "inline",
                  color: "#00000022",
                  position: "absolute",
                }}
              >
                888
              </p>
            </div>
          </Grid>
          <Grid item xs={4} className={classes.gridItems} style={{ position: "relative"}}>
          <div
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            top:"-25%",
            right:"-10%",
            padding: "2% 21% 0% 15%",
          }}
        >
          <CircularProgressbar
            // value={(tempo-59.0)/(240-60.0) * 100}
            value={100}
            strokeWidth={10}
            styles={buildStyles({
              strokeLinecap: "butt",
              trailColor: "#d6d6d622",
              pathColor: `rgb(0,180,0)`,
              rotation: 0.5,
              path: {
                strokeDasharray: "0 1",
              },
            })}
          ></CircularProgressbar>
        </div>
        <div
          className={classes.masterVolumeContainer}
          style={{
            // padding: `20% 27% 5% 31%`,
          }}
        >
          <Knob2
              style={{
                height: "100%",
                display: "inline-block",
                zIndex: 10,
                width: "90%",
                top: "-35%",
                right: "-5%",
                // opacity:0.3
              }}
              skin={tempoKnobSkin}
              min={0}
              max={360}
              lineColor="#00ff00"
              // step={0.5}
              mousePosition={true}
              value={transposeKnobValue}
              unlockDistance={50}
              onChange={handelTransposeChangeLocal}
              onStart={handelTransposeKnobStartChange}
              onClick={(e) => {
                if (e) return;
                // let diff = -transposeKnobValue;
                // handelTransposeChangeLocal(diff)
                resetTranspose();
              }}
            />
        </div>
            
          </Grid>
          <Grid item xs={5}>
            <div
              style={{
                backgroundImage: `url(${bigNextButton})`,
                height: "220%",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                width: "150%",
                position: "relative",
                top: "-103%",
                left: "-40%",
              }}
              onClick={handelNextTrack}
            >
              &nbsp;
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        style={{
          height: percentOfHeight(3.5),
          width: "100%",
        }}
      ></Grid>
      <Grid
        item
        className={classes.gridItems}
        style={{
          height: "2.5%",
          width: "100%",
          backgroundColor: "#00000050",
        }}
      ></Grid>
    </>
  );
}

export default LeftContainer;
